import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

// Styling
import { StyledResultPageContainer, FormLayout, MessageText } from '../../../../shared/styles/CommonStyle';

// Redux
import { resetSupportRequestForm } from '../../redux/SupportRequestFormSlice'
import { RootState } from '../../../../shared/stores'

// Components
import { Header } from '../../../../shared/components/Header';

export function SupportRequestResultPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { supportRequestloading, supportRequestSuccess, supportRequestError } = useSelector((state: RootState) => state.supportRequest);

    return (
      <FormLayout>
        <Header title="AIR Support Request Submission Result"/>
        <StyledResultPageContainer>
          {supportRequestloading ? (
            <>
              <Spinner animation="border" role="status"></Spinner>
              <MessageText>Submitting the form, please wait...</MessageText>
            </>
          ) : supportRequestSuccess ? (
            <MessageText>Support Request Form submit successful!</MessageText>
          ) : (
            <MessageText>Support Request Form submit failed: {supportRequestError}</MessageText>
          )}
          { supportRequestloading ? (null) :
           (<Button onClick={() => {
              dispatch(resetSupportRequestForm());
              navigate('/');
            }}>
              Submit Again
            </Button>)
          }
        </StyledResultPageContainer>
      </FormLayout>
    );
  }